import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { AppContext } from '@prisjakt/ui-app-context';
import Breadcrumb from '@prisjakt/ui-breadcrumb';

import * as S from './styles';
import Page from './components/page';
import { PageContent } from 'src/components/page';
import infoPagesQuery from './query.graphql';
import {
  trackInternalNavigationClick,
  InternalNavigationScope,
} from 'src/globals/tracking/tracking';

const InfoPages = props => {
  const { t } = useContext(AppContext);
  const { pageContent } = props.data;

  if (!pageContent) {
    return null;
  }
  return (
    <PageContent>
      <Breadcrumb
        homeText={t('common', 'breadcrumb.home')}
        path={[
          {
            id: '1',
            name: pageContent.title,
            pathName: pageContent.pathName,
          },
        ]}
        onClick={nextPage =>
          trackInternalNavigationClick({
            scope: InternalNavigationScope.BREADCRUMB,
            nextPage,
          })
        }
      />
      <S.Section>
        {pageContent.id === 6 && (
          <S.PrivacyLink>
            <Link to="/privacy-settings">
              {t('tracking-settings', 'link.privacy-settings')}
            </Link>
          </S.PrivacyLink>
        )}
        {pageContent && <Page {...pageContent} />}
      </S.Section>
    </PageContent>
  );
};

InfoPages.variables = ({ id }) => ({ id });

InfoPages.graphQL = infoPagesQuery;

InfoPages.loadOrder = [{}];

InfoPages.propTypes = {
  data: PropTypes.shape({
    pageContent: PropTypes.any,
  }),
};

InfoPages.defaultProps = {
  data: {
    pageContent: undefined,
  },
};

export default InfoPages;
